import React from 'react';
import { Menu } from 'lucide-react';
import { useSidebar } from '../context/SidebarContext';

export default function MobileTopBar({ title }) {
  const { setMobileOpen } = useSidebar();
  return (
    <div className="md:hidden sticky top-0 z-20 bg-[#F7F5FF]/90 backdrop-blur border-b border-[#E5DEF9] px-4 py-3 flex items-center gap-3">
      <button
        onClick={() => setMobileOpen(true)}
        className="w-9 h-9 rounded-lg bg-white border border-[#E5DEF9] flex items-center justify-center text-[#1A1533]"
        aria-label="Open menu"
      >
        <Menu size={18} />
      </button>
      <div className="flex items-baseline">
        <span className="text-[18px] font-extrabold text-[#0A3900]">Duty AI</span>
        <span className="text-[18px] font-extrabold text-[#5B4FE8]">.</span>
      </div>
      {title && <span className="text-[14px] font-semibold text-[#4A4463] ml-auto truncate">{title}</span>}
    </div>
  );
}
